export default function ArrayToOption(array, keyValue, keyLabel, otherField = false){
  const options = array.map( option => ({
    label: option[keyLabel], 
    value: option[keyValue],
    ...(otherField ? option : {})
  }))
  return options
}